<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text class="editor-content">
        <section class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name" hide-details/></v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </section>

        <SectionSettingsContainerFuild
          class="mb-4"
          :settings="fields.settings"
          :container-page="fields.containerPage"
          :show-container-page="false"
          :use-background-mobile="false"
          :show-background-image="false"
        />

        <section class="mb-4">
          <label class="label-input">Header</label>
          <div class="group-item">
            <p class="field-label">Title</p>
            <ckeditor :editor="editor" v-model="fields.header.title" :config="editorConfig" />
            <p class="field-label mt-4">Description</p>
            <ckeditor :editor="editor" v-model="fields.header.description" :config="editorConfig" />
          </div>
        </section>

        <section class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Slides</label>
            <v-btn small text color="primary" @click="handleAddSlide"> <v-icon small>mdi-plus</v-icon>Add slide </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(slide, index) in fields.slides" :key="`furnitureshop-grid-slide-02-${index}`">
              <v-expansion-panel-header>
                <span>Slide {{ index + 1 }}</span>
                <template #actions>
                  <v-btn icon @click.stop="handleRemoveSlide(index)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="field-label">Image</p>
                <UploadImage
                  :image="{ imageSrc: slide.image }"
                  :height="'180'"
                  :typeUpload="'image'"
                  @callback="obj => handleUploadSlideImage(obj, index)"
                  @callbackDelete="() => handleRemoveSlideImage(index)"
                />
                <p class="field-label mt-4">Content</p>
                <ckeditor :editor="editor" v-model="slide.content" :config="editorConfig" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </section>

        <ButtonPrimary :button="fields.button" />
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions>
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultSlide = () => ({
  image: '',
  content: '<h2 style="text-align: center"><strong>Title</strong></h2>',
});

export default {
  name: 'FurnitureshopGridSlider02',
  components: { ButtonPrimary, SectionSettingsContainerFuild, UploadImage },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Furnitureshop grid slider 02',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#2A2A2A',
          textColor: '#FFFFFF',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
        header: {
          title: '',
          description: '',
        },
        slides: [],
        button: {
          show: true,
          backgroundColor: '#FF8100',
          color: '#FFFFFF',
          radius: 4,
          text: 'Buy now',
          link: '#',
          iconPrefix: { show: false, src: '' },
          iconSuffix: { show: true, src: '' },
          subBtn: { show: false, text: '' },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(value) {
        if (value?.sectionExtract) this.applyExtract(value.sectionExtract);
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        header: { ...this.fields.header, ...(extract.header || {}) },
        slides: Array.isArray(extract.slides) ? extract.slides.map(slide => ({ ...slide })) : this.fields.slides,
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleAddSlide() {
      this.fields.slides.push(defaultSlide());
    },
    handleRemoveSlide(index) {
      this.fields.slides.splice(index, 1);
    },
    handleUploadSlideImage(obj, index) {
      if (this.fields.slides[index]) this.$set(this.fields.slides[index], 'image', obj?.imageSrc || '');
    },
    handleRemoveSlideImage(index) {
      if (this.fields.slides[index]) this.$set(this.fields.slides[index], 'image', '');
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionFurnitureshopGridSlider02(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable_inline {
  min-height: 100px;
}
</style>
